// src/app/core/constants/pin-dialog.copy.ts

export type PinDialogMode =
  | 'PACIENTE'
  | 'MEDICO'
  | 'TUTOR'
  | 'ADMIN'
  | 'MEDICAMENTOS_OCULTOS';

export const PIN_DIALOG_COPY: Record<
  PinDialogMode,
  { title: string; message: string; optional: boolean }
> = {
  PACIENTE: {
    title: 'PIN DE SEGURIDAD',
    message:
      'ESTA RECETA TIENE DETALLES OCULTOS. SI INGRESAS TU PIN PODRÁS VERLOS. SI PREFIERES, PUEDES CONTINUAR SIN PIN.',
    optional: true,
  },

  MEDICAMENTOS_OCULTOS: {
    title: 'MEDICAMENTOS OCULTOS',
    message:
      'EL PACIENTE PROTEGIÓ MEDICAMENTOS CON UN PIN. INGRESA EL PIN PARA VISUALIZAR LOS MEDICAMENTOS OCULTOS.',
    optional: true,
  },

  MEDICO: {
    title: 'RECETA PROTEGIDA',
    message:
      'EL PACIENTE PROTEGIÓ ESTA RECETA CON UN PIN. INGRESA EL PIN PARA VISUALIZAR LOS MEDICAMENTOS OCULTOS.',
    optional: true,
  },

  TUTOR: {
    title: 'ACCESO RESTRINGIDO',
    message:
      'ESTA RECETA ESTÁ PROTEGIDA POR UN PIN DEL PACIENTE. INGRESA EL PIN PARA CONTINUAR.',
    optional: true,
  },

  ADMIN: {
    title: 'ACCESO RESTRINGIDO',
    message:
      'ESTA RECETA ESTÁ PROTEGIDA POR UN PIN DEL PACIENTE. INGRESA EL PIN PARA CONTINUAR.',
    optional: true,
  },
};
